'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentCadhocAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.75879 35.9382H17.0483V23.5552H4.75879V35.9382Z",
          fill: "#F39301"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M29.5038 35.7584C28.9847 36.0649 28.0537 36.2273 27.4987 36.2273C23.7026 36.2273 21.1779 33.3587 21.1779 29.7506C21.1779 26.1783 23.7562 23.2734 27.4267 23.2734C28.0177 23.2737 28.9133 23.4179 29.4145 23.7246L29.8084 26.5933C29.1637 26.07 28.34 25.7091 27.3193 25.7091C25.1528 25.7091 23.6488 27.6577 23.6488 29.7506C23.6488 32.06 25.3677 33.7917 27.4267 33.7917C28.4115 33.7917 29.1814 33.2867 29.8261 32.7637L29.5038 35.7584ZM34.7146 34.3152C35.5204 34.3152 36.3795 33.828 36.3795 32.9981C36.3795 32.1861 35.5204 31.681 34.7146 31.681C33.9087 31.681 33.0491 32.1861 33.0491 32.9981C33.0491 33.828 33.9087 34.3152 34.7146 34.3152ZM35.1444 26.4849C34.267 26.4849 33.3714 26.5752 32.5123 26.7375L31.8854 28.9385C32.709 28.6137 33.5686 28.3972 34.4637 28.3972C35.5204 28.3972 36.4155 28.6321 36.4155 29.8767C36.4155 30.0352 36.3991 30.1692 36.3829 30.3007L36.3829 30.3007V30.3007L36.3829 30.3007L36.3829 30.3008L36.3829 30.3008L36.3829 30.3008L36.3829 30.3008L36.3829 30.3009C36.3752 30.3637 36.3675 30.426 36.3618 30.49C35.4845 30.0391 34.8398 29.8767 33.855 29.8767C32.154 29.8767 30.7754 31.3383 30.7754 32.9981C30.7754 35.0909 32.2792 36.2272 34.2133 36.2272C35.0547 36.2272 35.8605 35.9029 36.487 35.3616V36.1552L38.564 35.9387V29.0652C38.564 27.2066 36.7734 26.4849 35.1444 26.4849ZM44.5984 34.1344C46.1205 34.1344 47.2305 32.8536 47.2305 31.3562C47.2305 29.8589 46.1205 28.5775 44.5984 28.5775C43.0764 28.5775 41.9664 29.8589 41.9664 31.3562C41.9664 32.8536 43.0764 34.1344 44.5984 34.1344ZM44.3116 36.2272C45.565 36.2272 46.1919 35.9024 47.1408 34.9464V34.9465V36.1553L49.2897 35.9388V23.2735L47.0156 23.5622V27.4592C46.1742 26.7556 45.2249 26.485 44.3116 26.4851C41.7155 26.4851 39.8174 28.8124 39.8174 31.3562C39.8174 33.9 41.7155 36.2272 44.3116 36.2272ZM51.0444 23.5624L53.3181 23.2737V27.6397H53.3541C53.9988 26.7738 54.7505 26.4851 56.0221 26.4851C57.902 26.4851 59.1554 27.6939 59.1554 29.6424V35.9388L56.8812 36.0833V30.2558C56.8812 29.2814 56.4337 28.4699 55.4129 28.4699C53.9806 28.4699 53.3181 29.5704 53.3181 30.7246V35.9388L51.0444 36.0833V23.5626V23.5624ZM68.3409 31.3562C68.3409 32.9256 66.98 34.1344 65.4402 34.1344C63.9004 34.1344 62.5396 32.9256 62.5396 31.3562C62.5396 29.7868 63.9004 28.5775 65.4402 28.5775C66.98 28.5775 68.3409 29.7868 68.3409 31.3562ZM65.4402 26.4852C68.126 26.4852 70.4884 28.5961 70.4884 31.3562C70.4884 34.1165 68.126 36.2272 65.4402 36.2272C62.7545 36.2272 60.3911 34.1165 60.3911 31.3562C60.3911 28.5959 62.7545 26.4852 65.4402 26.4852ZM76.4365 28.578C77.132 28.578 77.7748 28.9023 78.3696 29.2634L79.5688 27.5495C78.5663 26.9 77.5446 26.485 76.2206 26.485C73.568 26.485 71.2223 28.5055 71.2223 31.2842C71.2223 34.3693 73.803 36.2273 76.1487 36.2273C77.3095 36.2273 78.6718 35.9566 79.5496 35.0726L78.2977 33.4312C77.5637 33.9179 77.0409 34.1344 76.1103 34.1344C74.9303 34.1344 73.496 32.944 73.496 31.3562C73.496 29.6965 74.7528 28.578 76.4365 28.578Z",
          fill: "#495654"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.63818 29.7307C9.63818 30.3692 9.49912 30.8595 8.78837 30.8595C7.99252 30.8595 7.90757 30.2835 7.90757 29.8164V26.1566L6.88757 26.3832L6.88759 29.9643C6.88759 31.3268 7.83021 31.8483 8.7419 31.8483C9.9319 31.8483 10.658 31.0779 10.658 30.1122V26.1566L9.63819 26.3832V29.7308L9.63818 29.7307ZM13.1672 30.9454C12.511 30.9454 12.0318 30.3925 12.0318 29.7464C12.0318 29.1002 12.511 28.5474 13.1672 28.5474C13.8243 28.5474 14.3035 29.1002 14.3035 29.7464C14.3035 30.3925 13.8243 30.9454 13.1672 30.9454ZM12.1272 27.9961C12.4448 27.7735 12.8194 27.6484 13.23 27.6484V27.6483C14.3357 27.6483 15.2322 28.5883 15.2322 29.7479C15.2322 30.9074 14.3357 31.8473 13.23 31.8473C12.8213 31.8473 12.4414 31.7187 12.1243 31.4983V32.8981L11.1431 33.1252V27.6539L12.1272 27.4141V27.9961Z",
          fill: "#FEFEFE"
        }
      )
    ]
  }
);
const VpPaymentCadhocAsset = forwardRef(PaymentCadhocAsset);

export { VpPaymentCadhocAsset as default };
